// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nkl-layout-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px !important;
  background: white !important;
  border-top: 1px solid #e6e6e6;
}
.nkl-layout-footer .copyright {
  font-size: 12px;
  margin-bottom: 12px;
}
@media (min-width: 768px) {
  .nkl-layout-footer {
    flex-direction: row;
  }
  .nkl-layout-footer .copyright {
    margin-right: auto;
    margin-bottom: unset;
  }
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
